﻿$.validator.addMethod("passwordCheck", function (value) {

    var validPassword = true;

    (value.length === 0) ? (msg = "Password is Required", validPassword = false) : msg = "Incorrect Password Format";

    (value.length < 8) ? ($("#minLength").removeClass("completed"), validPassword = false) : $("#minLength").addClass("completed");
    (!(/[a-z]/.test(value))) ? ($("#lowerCase").removeClass("completed"), validPassword = false) : $("#lowerCase").addClass("completed");
    (!(/[A-Z]/.test(value))) ? ($("#upperCase").removeClass("completed"), validPassword = false) : $("#upperCase").addClass("completed");
    (!(/[0-9]/.test(value))) ? ($("#oneNumber").removeClass("completed"), validPassword = false) : $("#oneNumber").addClass("completed");
    (!(/([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/.test(value))) ? ($("#oneSpecialChar").removeClass("completed"), validPassword = false) : $("#oneSpecialChar").addClass("completed");

    return validPassword;
}, "");

var rules = {
    quickPassword:
    {
        passwordCheck: true
    }
};

$("#PostEnquiryRegistration").validate({
    onclick: false,
    onfocusout: false,
    errorClass: "invalid",
    validClass: "valid",
    rules: rules,
    highlight: function (element, errorClass, validClass) {
        $(element).parent().removeClass(validClass).addClass(errorClass);
        $(element).closest('.quickpassword').removeClass(validClass).addClass(errorClass);
        $('#Continue').prop('disabled', true);

    },
    unhighlight: function (element, errorClass, validClass) {
        $(element).parent().removeClass(errorClass).addClass(validClass);
        $(element).closest('.quickpassword').removeClass(errorClass).addClass(validClass);
        $('#Continue').prop('disabled', false);

    },
    onkeyup: function (element) {
        $(element).valid();
    },
    errorPlacement: function (error, element) {
    },
    submitHandler: function (form) {

        //ajax call to register account
        $.ajax({
            url: '/service/RegisterAccount',
            method: 'POST',
            headers: { "x-csrf-token": $('[name=__RequestVerificationToken]', '#AjaxAntiForgery').val() },
            data: {
                email: $('#txtFrom').val(),
                password: $('#quick-pwd').val(),
                name: $("#txtName1").val()
            },
            success: function (data) {
                // Hide on Post Enquiry form the following etc
                $(".PostEnquiryAccount").slideUp();
                $("#registeredEmail").text(data.email);
                $(".qp-success").slideDown();

                if (data.email) {
                    var domain = data.email.split('@')[1];
                    if (["gmail.com", "googlemail.com", "live.com", "hotmail.com", "outlook.com"].indexOf(domain.toLowerCase()) > -1) {
                        $("#linktoinbox").append(linkToInbox.createLink(data.email));
                        $("#linktoinbox").show();
                    }
                }
            },
            error: function (err, status, thrown) {
                var ajaxErrorMessage = 'Error: Post Enquiry Register Account - ' +
                    (err.responseText || status || thrown || 'Unspecified error');
                rgdCommonLogHelper.NLogErrorAsync(ajaxErrorMessage);
            }
        });
    }
});
